import type { AnimationScope } from './animationScope';

interface Props {
  scope: AnimationScope;
  onChange: (scope: AnimationScope) => void;
  /** Why "This pack" is off right now; null when the selected pack can get its own opening. */
  packBlocker: string | null;
}

// Matches the theme editor's top-bar controls (h-7, px-3, font-mono 11px).
/** Whether the editor works on every pack's opening or on the selected pack's own. */
export function ScopeSelector({ scope, onChange, packBlocker }: Props) {
  return (
    <label className="flex items-center gap-1" title={packBlocker ?? undefined}>
      <span className="whitespace-nowrap font-mono text-[10px] uppercase tracking-wide text-neutral-400">
        Applies to
      </span>
      <select
        aria-label="Applies to"
        value={scope}
        onChange={(e) => onChange(e.target.value === 'pack' ? 'pack' : 'global')}
        className="h-7 rounded border border-neutral-700 bg-neutral-900 px-3 font-mono text-[11px] text-white outline-none hover:bg-neutral-800"
      >
        <option value="global">All packs</option>
        <option value="pack" disabled={packBlocker !== null}>
          This pack
        </option>
      </select>
    </label>
  );
}
